export const GENERAL_PURPOSE_SSD_GP3 = 'GP3';
export const DEVELOPMENT = 'development';
export const WINDOWS = 'Windows';
export const DATABASER_SERVER_ORACLE = 'Database server - Oracle';
export const DATABASER_SERVER_SQL = 'Database server - SQL';
export const WEB_SERVER = 'Web server';
export const FRONTEND = 'frontend';
export const BACKEND = 'backend';
export const SSDE = 'SSDE';
export const SSRS = 'SSRS';
export const DISK_TYPE_MAPPING = {
    GP2: 'gp2',
    GP3: 'gp3',
    IO1: 'io1',
    IO2: 'io2',
    Standard: 'standard',
};

export default {};
